import { http } from '@/shared/api'
import type { ApiSingleResponse } from '@/shared/api'
import type { ReadOptions } from '@/shared/lib'
import { API } from '@/apps/adok/shared/api'

import type { TelegramAccount } from '../model/types'

/** Hand-written rather than `createEntityApi`: a singular resource, no id in its path. */
export const getTelegramAccount = (options?: ReadOptions) =>
  http.get<ApiSingleResponse<TelegramAccount>>(API.telegramAccount, {
    signal: options?.signal
  })

export const getTelegramLink = () =>
  http.get<ApiSingleResponse<{ link: string }>>(`${API.telegramAccount}/link`)

export const disconnectTelegramAccount = () =>
  http.delete<void>(API.telegramAccount)
